import React from "react";
import template from 'template/common/form/form_country_select';
import CountryRepository from "../../../repository/country_repository";
import {_t} from "../../../../../common/utils/locale";

export default class FormCountrySelectComponent extends React.Component {

    repository = null;

    constructor(props) {
        super(props);

        this.repository = new CountryRepository();
        this.state = {
            countries: []
        };
    }

    componentDidMount() {
        this.repository.fetchList().then((countries) => {
            this.setState({
                countries: countries.sort((c1, c2) => _t(c1.name).localeCompare(_t(c2.name)))
            });
        });
    }

    render() {
        return template.bind(this)();
    }

}